import env from '@/config/env';
import { errorGQLHandler } from '../../../helpers/helpers';
import RegistraTrocaChip from '@/graphql/revista/mutations/RegistraTrocaChip.gql';
import VerificaPossibilidadeTrocaChip4G from '@/graphql/revista/queries/VerificaPossibilidadeTrocaChip4G.gql';

const SET_TROCA_CHIP = 'SET_TROCA_CHIP';
const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS';
const SET_PERMITE_TROCA = 'SET_PERMITE_TROCA';

export default {
  namespaced: true,
  state: {
    trocaChip: null,
    validationErrors: null,
    permiteTroca: false,
  },
  getters: {
    trocaChip: state => state.trocaChip,
    validationErros: state => state.validationErrors,
    permiteTroca: state => state.permiteTroca,
  },
  mutations: {
    [SET_TROCA_CHIP](state, payload) {
      state.trocaChip = payload;
    },
    [SET_VALIDATION_ERRORS](state, payload) {
      state.validationErrors = payload;
    },
    [SET_PERMITE_TROCA](state, payload) {
      state.permiteTroca = payload;
    },
  },
  actions: {
    async verificarPossibilidadeTrocaChip({ commit }, numero) {
      commit(SET_PERMITE_TROCA, false);

      try {
        const {
          data: { verificaPossibilidadeTrocaChip4G },
        } = await env.apolloRevista.query({
          query: VerificaPossibilidadeTrocaChip4G,
          variables: {
            numero,
          },
        });

        commit(SET_PERMITE_TROCA, verificaPossibilidadeTrocaChip4G);
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async storeTrocaChip({ commit }, { numero, filial }) {
      // jshint ignore:line
      commit(SET_TROCA_CHIP, null);

      try {
        const {
          data: { registarTrocaChip },
        } = await env.apolloRevista.mutate({
          mutation: RegistraTrocaChip,
          variables: {
            numero,
            filial,
          },
        });

        commit(SET_TROCA_CHIP, registarTrocaChip);
      } catch ({ graphQLErrors, networkError }) {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, validation }) => {
            if (message === 'validation') {
              const { filial_agvivo_id } = validation;
              const { numero } = validation;
              let validationMessages = [];
              if (filial_agvivo_id) {
                validationMessages = validationMessages.concat(filial_agvivo_id);
              }

              if (numero) {
                validationMessages = validationMessages.concat(numero);
              }

              commit(SET_VALIDATION_ERRORS, validationMessages);
            }
          });
        }
      }
    },
  },
};
